import { getCSSPartDemention } from "src/libs/utilities";
import { Border } from "../../data/interfaces";
import { BORDER_STYLE, CSSBorder } from "src/libs/interfaces/layouts";

export default function getBorderStyle(border: Border| undefined ): string {
    if(!border || !Object.keys(border).length) {
        return ""
    }
    return Object.keys(border).map((key: string) => getSingleBorderAttrib( border[key as  keyof Border], key as  keyof Border)).join("")
}

export function getSingleBorderAttrib(value: any , field: keyof Border) : string {
    if(typeof value === "undefined") {
        return ""
    }
    switch(field) {
        case "stroke":
            return `border-color: ${ value };`
        case "strokeWidth":
            return `border-width: ${ getCSSPartDemention(value) };`
        case "radius":
            return `border-radius: ${ 
                Array.isArray(value) 
                    ? 
                    value.map(v => getCSSPartDemention(v)).join(" ")
                    :
                    getCSSPartDemention(value) 
            };`
        default:
            return ""
    }
}
export function getSCCBorderStyle(border: CSSBorder| undefined ): string {
    if(!border || !Object.keys(border).length) {
        return ""
    }
    return [ 
        getSingleSCCBorderAttrib(BORDER_STYLE.SOLID, "borderStyle"),
        ...Object.keys(border).map((key: string) => getSingleSCCBorderAttrib( border[key as  keyof CSSBorder], key as  keyof CSSBorder))
    ]
    .join("")
}

export function getSingleSCCBorderAttrib(value: any , field: keyof CSSBorder) : string { 
    if(typeof value === "undefined") {
        return ""
    }
    switch(field) {
        case "borderStyle":
            return `border-style: ${ value || BORDER_STYLE.SOLID };`
        case "borderColor":
            return `border-color: ${ value };`
        case "borderWidth":
            return `border-width: ${ getCSSPartDemention(value, "0") };`
        case "borderRound":
            const border = value 
            return !!border.border 
                    ? 
                    Object.keys(border).length === 1
                        ?
                        `border-radius: ${ getCSSPartDemention(border.border) };`  
                        :
                        `
                        border-top-left-radius: ${ getCSSPartDemention(border.border)};
                        border-top-right-radius: ${ getCSSPartDemention(border.borderTopRight || border.border)};
                        border-bottom-left-radius: ${ getCSSPartDemention(border.borderBottomLeft || border.border)};
                        border-bottom-right-radius: ${ getCSSPartDemention(border.borderBottomRight || border.border)};
                        ` 
                    :
                    ``
        default:
            return ""
    }
}